
import { useParams } from 'react-router-dom';
import { ZonasFormState } from '../../../context/zonasentrega/ZonasFormState';
import { Form } from './form';

export const ZonasFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Zonas":"Crear Zonas";

  return (
    <ZonasFormState>
         <br />
        <Form title={title} />
    </ZonasFormState>
  );
};
